import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import AOS from "aos";
import "aos/dist/aos.css";

import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";
import banner5 from "../assets/banner5.jpg";
import banner6 from "../assets/banner6.jpg";
import banner7 from "../assets/banner7.jpg";

import {
  FaKitchenSet,
  FaUtensils,
  FaBoxesStacked,
  FaCouch,
  FaLightbulb,
  FaVectorSquare,
  FaCubes,
  FaArrowRight
} from "react-icons/fa6";

export default function ServicesBannerKitchenKings() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
    AOS.init({ duration: 800, easing: "ease-out-cubic", once: true });
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  const services = [
    {
      title: "Kitchen Cabinets",
      image: banner1,
      icon: <FaKitchenSet />,
      desc: "Custom-designed kitchen cabinets built for functionality, durability, and style.",
      navTo: { item: "services", subItem: "cabinets" }
    },
    {
      title: "Bar & Restaurant Furniture",
      image: banner2,
      icon: <FaUtensils />,
      desc: "Durable and stylish furniture solutions for bars and restaurants.",
      navTo: { item: "services", subItem: "bar" }
    },
    {
      title: "Furnishing Materials Supply",
      image: banner3,
      icon: <FaBoxesStacked />,
      desc: "Supply and distribution of quality furnishing and decorative materials.",
      navTo: { item: "services", subItem: "furnishing" }
    },
    {
      title: "Custom Wooden Furniture",
      image: banner4,
      icon: <FaCouch />,
      desc: "Bespoke wooden furniture crafted to fit your space and lifestyle.",
      navTo: { item: "services", subItem: "wooden" }
    },
    {
      title: "Ceiling Design & Lightings",
      image: banner5,
      icon: <FaLightbulb />,
      desc: "Modern ceiling designs integrated with professional lighting systems.",
      navTo: { item: "services", subItem: "ceiling" }
    },
    {
      title: "Tempered Glass Works",
      image: banner6,
      icon: <FaVectorSquare />,
      desc: "Premium tempered glass solutions for kitchens, partitions, and interiors.",
      navTo: { item: "services", subItem: "glass" }
    },
    {
      title: "3D Interior Design",
      image: banner7,
      icon: <FaCubes />,
      desc: "Photorealistic 3D interior designs to visualize and refine your space.",
      navTo: { item: "services", subItem: "interior" }
    }
  ];

  return (
    <section className="MainBodySection py-5">
      <div className="container">

        {/* Header */}
        <div className="row justify-content-center mb-5 text-center">
          <div className="col-lg-8">
            <h2 className="font-bold mb-3" data-aos="fade-down">
              Our Services
            </h2>
            <p className="text-dim" data-aos="fade-up">
              Premium kitchen, furniture, and interior solutions for residential and commercial spaces.
            </p>
          </div>
        </div>

        {/* First Row (3 items) */}
        <div className="row g-4 justify-content-center mb-2">
          {services.slice(0, 3).map((svc, idx) => (
            <div
              key={idx}
              className="col-md-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay={idx * 120}
            >
              <ServiceCard svc={svc} nav={appContext.navTo} />
            </div>
          ))}
        </div>

        {/* Second Row (4 items) */}
        <div className="row g-4 justify-content-center">
          {services.slice(3).map((svc, idx) => (
            <div
              key={idx}
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay={(idx + 3) * 120}
            >
              <ServiceCard svc={svc} nav={appContext.navTo} />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

/* Reusable Card */
function ServiceCard({ svc, nav }) {
  return (
    <div
      onClick={() => nav(svc.navTo)}
      className="h-100"
      style={{
        background: "#fff",
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 14px 35px rgba(0,0,0,0.08)",
        cursor: "pointer",
        transition: "all 0.35s ease"
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-8px)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
    >
      <img
        src={svc.image}
        alt={svc.title}
        className="w-100"
        style={{ height: "200px", objectFit: "cover" }}
      />

      <div className="p-4">
        <div
          style={{
            width: "46px",
            height: "46px",
            borderRadius: "12px",
            background: "#00356d",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1.25rem",
            marginBottom: "14px"
          }}
        >
          {svc.icon}
        </div>

        <h6 className="font-bold mb-2">{svc.title}</h6>

        <p className="text-dim mb-3" style={{ fontSize: "0.9rem", lineHeight: 1.6 }}>
          {svc.desc}
        </p>

        <div className="d-flex align-items-center gap-2 text-primary font-semi-bold" style={{ fontSize: "0.85rem" }}>
          View Service <FaArrowRight />
        </div>
      </div>
    </div>
  );
}
